import React from 'react';
import '../styles/components/About.scss';

const About = ({ isHomepage = false }) => {
  const coreValues = [
    {
      icon: 'fas fa-star',
      title: 'Excellence',
      description: 'We strive to deliver top-tier services and solutions, ensuring our clients receive nothing but the best.'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Integrity',
      description: 'Honesty and transparency are at the heart of everything we do, fostering trust and strong relationships.'
    },
    {
      icon: 'fas fa-lock',
      title: 'Confidentiality',
      description: 'We respect and safeguard our clients\' sensitive information, maintaining the utmost discretion.'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovation',
      description: 'We embrace creativity and modern approaches to develop impactful and sustainable solutions.'
    },
    {
      icon: 'fas fa-check-circle',
      title: 'Accountability',
      description: 'We take full responsibility for our work, ensuring we meet and exceed expectations in every project.'
    }
  ];

  const partners = [
    {
      id: 1,
      name: 'Mr. Sydney Mupeta',
      title: 'Managing Partner - Research & Consulting',
      image: '/images/partners/mrsm.jpg',
      description: 'Sydney Mupeta is a Lecturer in Civic Education, Governance, Public Policy, and Development in the Faculty of Languages and Social Science Education at the University of Zambia. He is currently finalizing a PhD in Public Administration (Governance and Development) at the University of the Western Cape, South Africa',
      additionalInfo: 'At Dythel Consulting Ltd, Sydney serves as the Managing Partner responsible for Research and consultancy, providing leadership in governance, public policy, and development studies. His research interests include governance systems, consensus democracy, civic participation, and policy processes.',
      expertise: [
        'Political economy analysis',
        'Governance',
        'Public policy analysis',
        'Education consultancies'
      ],
      role: 'With a strong grounding in qualitative and quantitative research methods, Sydney oversees Baseline, Mid-line, and endline project evaluations',
    },
    {
      id: 2,
      name: 'Dr. Gabriel Simungala',
      title: 'Managing Partner -Management & Administration',
      image: '/images/partners/mrgs.JPG',
      description: 'Dr. Gabriel Simungala holds a PhD in Linguistics from the University of the Western Cape and serves as a Lecturer in the Faculty of Humanities and Social Sciences at the University of Zambia.',
      additionalInfo: 'He is the Managing Partner at Dythel Consulting Ltd, where he leads the Administration portfolio, providing strategic oversight for programme design, evaluation, and institutional strengthening.',
      expertise: [
        'Language and governance',
        'Communication for development',
        'Social semiotics',
        'Linguistic landscapes',
        'Policy discourse analysis'
      ],
      role: 'With a strong background in language and communication, Dr. Simungala oversees the translation and interpreting components of projects, ensuring that all aspects of language proficiency.'
    }
  ];

  return (
    <section className={`about ${isHomepage ? 'about-homepage' : 'about-full'}`}>
      <div className="container">
        {isHomepage ? (
          <>
            <div className="about-header">
              <h2 className="section-title">About Dythel Consulting</h2>
              <p className="section-subtitle">
                Redefining the consulting landscape with modern, innovative, and high-quality services
              </p>
            </div>
            
            <div className="about-content">
              <div className="about-main">
                <div className="about-text">
                  <p>
                    At <strong>Dythel Consulting</strong>, we break through traditional systems to bring modern, 
                    innovative, and high-quality services to institutions across various sectors. Established in 
                    <strong> April 2021</strong> and formally registered in <strong>October 2024</strong>, we bring 
                    a wealth of expertise in knowledge generation, capacity building, and organizational development.
                  </p>
                  
                  <div className="about-highlights">
                    <div className="highlight-item">
                      <i className="fas fa-rocket"></i>
                      <span>Innovative Approach</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-chart-line"></i>
                      <span>Proven Results</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-users"></i>
                      <span>Expert Team</span>
                    </div>
                  </div>

                  <div className="about-cta">
                    <a href="/about" className="btn btn-primary">
                      <i className="fas fa-book-open"></i>
                      Learn More About Us
                    </a>
                  </div>
                </div>
                
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="about-header">
              <h2 className="section-title">About Us</h2>
              <p className="section-subtitle">
                Simplifying Service, Elevating Standards
              </p>
            </div>

            <div className="about-content">
              <div className="about-main">
                <div className="about-text">
                  <div className="intro-section">
                    <p className="lead">
                      At <strong>Dythel Consulting</strong>, we redefine the consulting landscape, breaking through 
                      traditional systems to bring modern, innovative, and high-quality services to institutions 
                      across various sectors.
                    </p>
                    
                    <p>
                      Established in <strong>April 2021</strong> and formally registered in <strong>October 2024</strong>, 
                      we bring a wealth of expertise in knowledge generation, capacity building, and organizational 
                      development. Our approach challenges the status quo by focusing on integrity, expertise, and 
                      tailored solutions.
                    </p>
                  </div>

                  <div className="mission-vision">
                    <div className="mission">
                      <div className="mission-header">
                        <i className="fas fa-bullseye"></i>
                        <h3>Our Mission</h3>
                      </div>
                      <p>
                        To be a center of excellence in generating credible and reliable information that facilitates 
                        evidence-based decision-making for sustainable development.
                      </p>
                    </div>

                    <div className="vision">
                      <div className="vision-header">
                        <i className="fas fa-eye"></i>
                        <h3>Our Vision</h3>
                      </div>
                      <p>
                        To become a leader in providing exceptional consultancy services, setting industry standards, 
                        and achieving global recognition for innovation and integrity within the next five years.
                      </p>
                    </div>
                  </div>

                </div>
              </div>

              <div className="core-values">
                <div className="values-header">
                  <h3>Our Core Values</h3>
                  <p>These principles guide everything we do and define how we deliver exceptional value to our clients</p>
                </div>
                
                <div className="values-grid">
                  {coreValues.map((value, index) => (
                    <div key={index} className="value-card">
                      <div className="value-icon">
                        <i className={value.icon}></i>
                      </div>
                      <div className="value-content">
                        <h4>{value.title}</h4>
                        <p>{value.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Our Partners Section - Updated */}
              <div className="our-partners">
                <div className="partners-header">
                  <h3>Our Managing Partners</h3>
                  <p>Meet the visionary leaders driving excellence and innovation at Dythel Consulting</p>
                </div>
                
                <div className="partners-grid">
                  {partners.map((partner) => (
                    <div key={partner.id} className="partner-card">
                      {/* Hero Image Section - Full image display */}
                      <div className="partner-hero-section">
                        <div className="partner-image-container">
                          <img 
                            src={partner.image} 
                            alt={partner.name}
                            className="partner-main-image"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              const container = e.target.parentElement;
                              if (container) {
                                container.innerHTML = `
                                  <div class="image-placeholder">
                                    <div class="initials">${partner.name.split(' ').map(n => n[0]).join('')}</div>
                                  </div>
                                  <div class="partner-overlay-content">
                                    <div class="partner-name-title">
                                      <h4 class="partner-name">${partner.name}</h4>
                                      <div class="partner-title">${partner.title}</div>
                                    </div>
                                  </div>
                                `;
                              }
                            }}
                          />
                          <div className="partner-overlay-content">
                            <div className="partner-name-title">
                              <h4 className="partner-name">{partner.name}</h4>
                              <div className="partner-title">{partner.title}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="partner-content">
                        <p className="partner-description">{partner.description}</p>
                        <p className="partner-additional-info">{partner.additionalInfo}</p>
                        
                        {partner.currentProjects && (
                          <div className="partner-projects">
                            <h5>Current Engagements & Projects</h5>
                            <div className="projects-grid">
                              {partner.currentProjects.map((project, index) => (
                                <div key={index} className="project-item">
                                  <div className="project-icon">
                                    <i className="fas fa-tasks"></i>
                                  </div>
                                  <div className="project-content">
                                    <p>{project}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        
                        {partner.expertise && (
                          <div className="partner-expertise">
                            <h5>Research Interests & Expertise</h5>
                            <div className="expertise-tags">
                              {partner.expertise.map((item, index) => (
                                <span key={index} className="expertise-tag">
                                  <i className="fas fa-check-circle"></i>
                                  {item}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                        
                        {partner.role && (
                          <div className="partner-role-section">
                            <h5>Role at Dythel Consulting</h5>
                            <p className="partner-role">{partner.role}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="about-cta-full">
                <div className="cta-content">
                  <h3>Ready to Work With Us?</h3>
                  <p>Let's discuss how we can help your organization achieve its goals with our expert consulting services.</p>
                  <div className="cta-buttons">
                    <a href="/contact" className="btn btn-primary">
                      <i className="fas fa-paper-plane"></i>
                      Get In Touch
                    </a>
                    <a href="/services" className="btn btn-secondary">
                      <i className="fas fa-chart-line"></i>
                      View Our Services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default About;